import { render } from "./PopupConfirmationGuest.vue?vue&type=template&id=d90bf204&scoped=true"
import script from "./PopupConfirmationGuest.vue?vue&type=script&lang=js"
export * from "./PopupConfirmationGuest.vue?vue&type=script&lang=js"

import "./PopupConfirmationGuest.vue?vue&type=style&index=0&id=d90bf204&scoped=true&lang=css"

import exportComponent from "F:\\homework\\tokenza\\tokenza_airdrop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d90bf204"]])

export default __exports__